import { Button, Col, Form, Row, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import { Excel } from "antd-table-saveas-excel";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { convertToGregorian, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { NotFound } from "../../../../sources/svg/svg";
import Loading from "../../../auxiliary/loader/loading";
import styles from "./assignKitToDealer.module.scss";

// مخزن توزیع کننده؛ تو این تب همیشه ثابته و قابل انتخاب نیست
const DISTRIBUTOR_POOL_TYPE = 3;

const KIT_COLUMNS = [
	{ title: "شماره کیت", dataIndex: "kitNo", key: "kitNo", width: 150 },
	{ title: "نوع مخزن", dataIndex: "poolType", key: "poolType", width: 180 },
	{ title: "وضعیت", dataIndex: "requestStatus", key: "requestStatus", width: 150 },
];

const AssignedToMe = () => {
	const [frmSearch] = Form.useForm();

	const { queryAssignedKit, queryKitAssignedToUser } = useDealer();

	const [groups, setGroups] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [downloadingKey, setDownloadingKey] = useState(null);

	// state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	const handleSearch = async () => {
		setIsLoading(true);
		try {
			const values = frmSearch.getFieldsValue();

			const payload = {
				searchConfigModel: {
					sort: "",
					filter: "",
					entriesPerPage: 10,
					page: currentPage === 0 ? 0 : currentPage - 1,
					totalRowCount: 0,
				},
				poolType: [DISTRIBUTOR_POOL_TYPE],
			};

			if (values?.fromdate) {
				payload.fromDate = convertToGregorian(values.fromdate.format("YYYY-MM-DD"), "-", "-");
			}

			if (values?.todate) {
				payload.toDate = convertToGregorian(values.todate.format("YYYY-MM-DD"), "-", "-");
			}

			const response = await queryAssignedKit(payload);

			if (response) {
				const kits = response?.Result || [];

				// خروجی سرویس تخت (هر کیت یه ردیف) هست؛ بر اساس requestId درخواست دسته‌بندی می‌کنیم تا هر درخواست یه ردیف بشه
				const grouped = kits.reduce((acc, item) => {
					const key = item.requestId || "";
					if (!acc[key]) {
						acc[key] = [];
					}
					acc[key].push(item);
					return acc;
				}, {});

				setGroups(
					Object.entries(grouped).map(([requestId, items]) => ({
						transferDate: items[0]?.dtE_TransferDate,
						count: items[0]?.iccidCount || items.length,
						// شناسه‌ی درخواست برای فراخوانی QueryKitAssignedToUser
						requestId,
					})),
				);
				setTotalRecord(response?.searchconfigmodel?.totalrowcount || 0);
			}
		} catch (error) {
			console.error("Failed to load assigned-to-me kits:", error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		handleSearch();
	}, [currentPage]);

	// دریافت لیست کیت‌های همین دسته از سرویس (نه از دیتای از قبل گرفته‌شده) و خروجی اکسل
	const handleDownload = async (group) => {
		if (!group.requestId) return;
		setDownloadingKey(group.transferDate);
		try {
			const kits = (await queryKitAssignedToUser({ iccidRequestId: group.requestId })) || [];
			if (kits.length > 0) {
				const excel = new Excel();
				excel
					.addSheet("کیت‌های تخصیصی به من")
					.addColumns(KIT_COLUMNS)
					.addDataSource(
						kits.map((item, key) => ({
							key,
							kitNo: item.kitNo,
							poolType: item.poolType,
							requestStatus: item.requestStatus,
						})),
						{ str2Percent: true },
					)
					.saveAs("assigned-to-me-kits.xlsx");
			}
		} catch (error) {
			console.error("Failed to export assigned-to-me kits:", error);
		}
		setDownloadingKey(null);
	};

	const columns = [
		{
			title: "تاریخ تخصیص",
			dataIndex: "transferDate",
			key: "transferDate",
			width: 150,
			sorter: (a, b) => new Date(a.rawTransferDate || 0) - new Date(b.rawTransferDate || 0),
		},
		{
			title: "تعداد کیت",
			dataIndex: "count",
			key: "count",
			width: 120,
		},
		{
			title: "عملیات",
			dataIndex: "action",
			key: "action",
			width: 220,
		},
	];

	const dataSource = groups.map((group, key) => ({
		key,
		rawTransferDate: group.transferDate,
		transferDate: convertToJalaliWithoutTime(group.transferDate),
		count: group.count,
		action: (
			<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
				<Link
					to={_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignedKitList}
					state={{ requestId: group.requestId }}
					style={{ color: "var(--aptel)", textDecoration: "underline" }}>
					لیست کیت
				</Link>
				<Button
					className="btn-normal"
					style={{ width: "auto" }}
					loading={downloadingKey === group.transferDate}
					onClick={() => handleDownload(group)}>
					دانلود
				</Button>
			</div>
		),
	}));

	return (
		<>
			<div className={`holder-form-filter ${styles.holder_assign_kit}`}>
				<Form form={frmSearch} layout="vertical" onFinish={handleSearch}>
					<Row gutter={16} align="bottom">
						<Col>
							<JalaliLocaleListener />
							<Form.Item className="input-normal" name="fromdate" label="از تاریخ">
								<DatePickerJalali format="YYYY/MM/DD" placeholder="از تاریخ" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item className="input-normal" name="todate" label="تا تاریخ">
								<DatePickerJalali format="YYYY/MM/DD" placeholder="تا تاریخ" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item className="hold_btn_cus" label="">
								<Button htmlType="submit" className="btn-normal btn-aptel" icon={<SearchOutlined />} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</div>

			<div className="holder-table">
				<Table
					className="tbl-normal"
					columns={columns}
					locale={{
						emptyText: <NotFound text={"رکوردی یافت نشد."} />,
					}}
					pagination={{
						className: "page-pagination",
						onChange: (page) => {
							setCurrentPage(page);
						},
						pageSize: 10,
						align: "start",
						current: currentPage === 0 ? 1 : currentPage,
						total: totalRecord,
						showSizeChanger: false,
					}}
					scroll={{ y: "100%" }}
					dataSource={dataSource}
				/>
			</div>

			<Loading isOpen={isLoading} />
		</>
	);
};

export default AssignedToMe;
